import { mount } from 'svelte'
import './app.css'
import App from './App.svelte'
import init from "../../wasm/engine.js";

async function run() {
  await init();              // Loads engine_bg.wasm

  const app = mount(App, {
    target: document.getElementById('app')!,
  })

  // Fade in the body once the app is mounted
  requestAnimationFrame(() => {
    document.body.classList.add('loaded');
  });

  return app;
}

run();
